var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"chip",class:{'chip--active': _vm.active},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('v-icon',{staticClass:"ml-2 chip__icon"},[_vm._v("fas fa-times-circle")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }